import useSWR from "swr";
import { simpleFetcher } from "../fetcher";
import { type WorkflowStepType } from "../types";

const url = "/api/v2/workflows/my-todos";

export const TodoTypes = {
  activeStep: "activeStep",
  stepToMove: "stepToMove",
  stepMissingUsers: "stepMissingUsers",
  documentToRead: "documentToRead",
  invitedToQuiz: "invitedToQuiz",
} as const;

export type TodoItem =
  ActiveStep | StepToMove | StepMissingUsers | DocumentToRead | InvitedToQuiz;

interface OwnerSummary {
  userId: number;
  firstName: string;
  lastName?: string;
  imageUrl?: string;
}

interface ActiveStep {
  id: string;
  todoType: "activeStep";
  documentId: number;
  title: string;
  dueDate: string | null;
  artifactReviewTo: string | null;
  stepType: WorkflowStepType;
  owner: OwnerSummary;
}

export const MoveTypes = {
  forwards: "forwards",
  backwards: "backwards",
  publish: "publish",
} as const;

type MoveType = (typeof MoveTypes)[keyof typeof MoveTypes];

interface StepToMove {
  id: string;
  todoType: "stepToMove";
  documentId: number;
  title: string;
  moveType: MoveType;
  dueDate: string | null;
  artifactReviewTo: string | null;
  rejector?: {
    userId: number;
    firstName: string;
    lastName: string;
  };
  owner: OwnerSummary;
}

interface StepMissingUsers {
  id: string;
  todoType: "stepMissingUsers";
  documentId: number;
  title: string;
  stepName: string;
  dueDate: string | null;
  artifactReviewTo: string | null;
  owner: OwnerSummary;
}

interface DocumentToRead {
  id: string;
  todoType: "documentToRead";
  documentId: number;
  releaseId: number;
  title: string;
  adoptedAt: string | null;
  publishedAt: string | null;
  owner: OwnerSummary;
}

interface InvitedToQuiz {
  id: string;
  todoType: "invitedToQuiz";
  quizId: number;
  documentId: number;
  releaseId: number;
  title: string;
  createdAt: string;
  owner: OwnerSummary;
}

export function useMyTodos() {
  return useSWR<TodoItem[], Error>(url, simpleFetcher);
}
